import { IconButton, IconExitFullScreenLine, IconFullScreenLine } from '@smarterservices/smarter-ui';
import { getStore } from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';
import NavigationalToolTip from '@ui/shared/components/Common/NavigationalToolTip';
const FullScreen = () => {

  const AppStore = getStore('appStore');
  const LayoutStore = getStore('layoutStore');

  if (!AppStore.enabledComponents.allowFullScreen) return null;

  return (
    <>
      {document.fullscreenElement ? (
        <NavigationalToolTip description="Exit Fullscreen" shortcut={CONSTANTS?.KEYBOARD_SHORTCUTS?.VIEW?.OPTIONS?.TOGGLE_FULLSCREEN?.KEY}>
          <IconButton
            as="span"
            size="small"
            style={{ zIndex: '99999' }}
            margin="none none none x-small"
            screenReaderLabel="Pause Playback"
            onClick={() => LayoutStore.exitFullScreen()}
          >
            <IconExitFullScreenLine size="x-small" />
          </IconButton>
        </NavigationalToolTip>
      ) : (
        <NavigationalToolTip description="Enter Fullscreen" shortcut={CONSTANTS?.KEYBOARD_SHORTCUTS?.VIEW?.OPTIONS?.TOGGLE_FULLSCREEN?.KEY}>
          <IconButton
            as="span"
            size="small"
            style={{ zIndex: '99999' }}
            margin="none none none x-small"
            screenReaderLabel="Start Playback"
            onClick={() => LayoutStore.enterFullScreen()}
          >
            <IconFullScreenLine size="x-small" />
          </IconButton>
        </NavigationalToolTip>
      )}
    </>


  );
};

export default FullScreen;
